import React, { useRef } from 'react'
import AppHeader from '../../components/main/AppHeader'
import './style.css';
import NameSection from './sections/NameSection';
import AboutSection from './sections/AboutSection';
import FocusSection from './sections/FocusSection';
import WorksSection from './sections/WorksSection';
import TestmonialSection from './sections/TestmonialSection';
import ContactSection from './sections/ContactSection';
import AppFooter from '../../components/main/AppFooter';
import { App2 } from './components/spiderNameModel';
import { useNavigate } from 'react-router-dom';

export default function HomePage(props) {
    const navigate = useNavigate();
    const landingPageRef = useRef();
    const aboutPageRef = useRef();
    const workPageRef = useRef();
    const contacPageRef = useRef();
    const onLogoClick =()=>{
        landingPageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
    }
    const onTabCLick =(tab)=>{
        if(tab == "ABOUT"){
            aboutPageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
        }else if(tab == "WORK"){
            navigate("/projects");
            // workPageRef.current.scrollIntoView({
            //     behavior: "smooth",
            //     block: "start"
            //   });
        }else if(tab == "CONTACT"){
            contacPageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
        }
       
    }
   
    return (
        <div  className='home-main'>
               <div style={{height:0}} ref={landingPageRef} />
            <AppHeader onTabCLick={onTabCLick} onLogoClick={onLogoClick} />
            <NameSection />
            <div style={{height:0}} ref={aboutPageRef} />
            <AboutSection />
            <FocusSection />
            <div style={{height:0}} ref={workPageRef} />
            <WorksSection />
            <TestmonialSection />
            <div style={{height:0}} ref={contacPageRef} />
            <ContactSection />
            <AppFooter />
         
        </div>
 
    )
}
